import React from "react";
import Img from "../../common/util/Img";
import { getConfiguration } from "../../data/utils";

function StreamingIcon(props) {
    const conf = getConfiguration();

    return (conf.lstwc?
            <Img src={props.src || "assets\img\sport\icone\tv-streaming.svg"} alt={props.alt}  />
            :
            <Img {...props} ></Img>

    )
}

export default StreamingIcon;